import "@radix-ui/themes/styles.css"
import { UserSecurity, UserSessions, WorkOsWidgets } from "@workos-inc/widgets"
import "@workos-inc/widgets/styles.css"
import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import ResetPassword from "src/main/Account/Settings/ResetPassword"

import HeadingPageTitle from "src/components/Heading/HeadingPageTitle"

import { queryApi } from "src/utils/api/ApiMethods"

const fetchWidgetToken = () =>
  queryApi("/account/settings/login_and_security/widget_token")

const WorkOsUserSecurityPanel = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["workosUserSecurityWidgetToken"],
    queryFn: fetchWidgetToken,
    staleTime: 5 * 60 * 1000,
  })

  if (isLoading) {
    return <p>Loading security settings…</p>
  }

  if (isError || !data?.token) {
    return (
      <p>
        We could not load your security settings. Please refresh the page or
        contact mayday@dockwa.com.
      </p>
    )
  }

  return (
    <WorkOsWidgets>
      <UserSecurity authToken={data.token} />
      <div>
        <br />
        <h4>Sessions</h4>
        <UserSessions
          authToken={() => Promise.resolve(data.token)}
          currentSessionId={data.workos_session_id}
        />
      </div>
    </WorkOsWidgets>
  )
}

const LoginAndSecurity = ({
  minimumPasswordLength,
  workosUserSecurityWidgetEnabled,
}) => (
  <div className="grid grid-cols-12">
    <div className="col-span-12 mb-8 mt-1">
      <HeadingPageTitle>Login and Security</HeadingPageTitle>
    </div>
    <div className="col-span-12 lg:col-span-6">
      {workosUserSecurityWidgetEnabled ? (
        <WorkOsUserSecurityPanel />
      ) : (
        <ResetPassword minimumPasswordLength={minimumPasswordLength} />
      )}
    </div>
  </div>
)

LoginAndSecurity.propTypes = {
  minimumPasswordLength: PropTypes.number.isRequired,
  workosUserSecurityWidgetEnabled: PropTypes.bool.isRequired,
}

export default LoginAndSecurity
